module.exports = __webpack_public_path__ + "img/usflag.06b09034.svg";